import React from 'react';
import '../../sass/main.scss';

const Brand = () => {
    return <div className="Brand">
              <div className="Brand-line"></div>
              <p className="Brand-brand">brand</p>
              <h1>VESTIGE</h1>
              <div className="Brand-description">
                  <p> Vestige znači trag. Mi želimo ostaviti dubok trag. Elegancija uvijek
                      na prvom mjestu. </p>
              </div>
           </div>
}

export default Brand;